import BaseService from '../../BaseService'

export default class EinladungService extends BaseService {

  constructor(prefix, id) {
    super(`${prefix}/${id}/einladung`);
  }

  async findByEmail(email) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}?email=${email}`, {
        method: 'GET',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }

  async count(params, serviceName) {
    return this.search(serviceName, params, 'HEAD')
      .then(res => Number(res.headers.get('x-count')))
  }

}
